<div class="row mt-3 mb-3">
  <div class="col-sm-12">
    <div class="row" *ngIf="!(isMobile | async)">
      <ng-container *ngFor="let step of stepper">
        <div class="col-sm-6 d-flex justify-content-center">
          <div class="step-div border rounded-circle" [ngClass]="step.status">
            <li class="nav-item letter-div">
              <a class="stepLetter" role="button">
                {{ step.id }}
              </a>
            </li>
          </div>
          <div class="stepper-text">
            {{ step.name }}
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row d-flex justify-content-center" *ngIf="(isMobile | async)">
      <ng-container *ngFor="let step of stepper">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-3 w-25">
              <div class="step-div border rounded-circle" [ngClass]="step.status">
                <li class="nav-item letter-div">
                  <a class="stepLetter" role="button">
                    {{ step.id }}
                  </a>
                </li>
              </div>
            </div>
            <div class="col-sm-9 w-75">
              <div class="stepper-text">
                {{ step.name }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="activeStep == 1">
      <div class="row justify-content-center" *ngIf="(newRentalQuoteError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not create Quote'"></tan-alert-message>
        </div>
      </div>

      <div class="container custom-section">
        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="section-heading">Basic details</span>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="guidance-text">Required fields are indicated with a <strong>'*'</strong></span>
          </div>
        </div>

        <form class="mt-3" [formGroup]="quoteForm">
          <div class="row form-group" *ngIf="isStaff">
            <div class="col-sm-4">
              <label class="control-label" for="customer">* Customer</label>
              <input type="text" class="form-control" formControlName="customer" placeholder="Please select a customer">
            </div>
            <div class="col-sm-2 top-margin">
              <div class="btn-group fr">
                <button id="CustomersByButton" type="button" class="btn btn-primary dropdown-toggle"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span>Search Customer</span>
                </button>
                <div class="dropdown-menu p-0 dropdown-menu-position" aria-labelledby="CustomersByButton">
                  <div class="dropdown-divider m-0"></div>
                  <div class="form-group select-margin-bottom search-dropdown-box p-1 m-0">
                    <input class="form-control" id="search-text" type="text" formControlName="searchCustomer"
                      [(ngModel)]="searchText" (ngModelChange)="searchCustomers()" placeholder="Search customers" />
                  </div>
                  <div class="dropdown-divider m-0"></div>

                  <div class="search-items">
                    <tan-loader [loading]="(customersLoading$ | async)" [loadingText]="'<p>Searching customers</p>'">
                    </tan-loader>
                    <div *ngIf="!(customersLoading$ | async) && customers.length > 0">
                      <button class="dropdown-item" (click)="setSelectedCustomer(customer)"
                        *ngFor="let customer of customers">
                        {{ customer.firstName }} {{ customer.lastName }}</button>
                    </div>
                    <div *ngIf="!(customersLoading$ | async) && customers.length == 0">
                      <button class="dropdown-item">No customers found</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6" *ngIf="showLocationDD">
              <label class="control-label" for="quote_location">* Select Location</label>
              <select class="form-control" formControlName="quote_location" id="quote_location"
                (change)="setSelectedQuoteLocation()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let local of quoteLocations" [ngValue]="local.id">{{ local.name }}</option>
              </select>
            </div>
          </div>

          <ng-container *ngIf="!isStaff && isCustomer && showLocationDD">
            <div class="form-group mb-0">
              <label class="control-label" for="quote_location">Select Location</label>
              <select class="form-control" formControlName="quote_location" id="quote_location"
                (change)="setSelectedQuoteLocation()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let local of quoteLocations" [ngValue]="local.id">{{ local.name }}</option>
              </select>
            </div>
            <div class="row mb-2">
              <div class="col-sm-12">
                <span class="guidance-text">Choose Klipriver if your closest area is not in the list</span>
              </div>
            </div>
          </ng-container>

          <div class="row form-group">
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="building_type">* Building Type</label>
              <select class="form-control" formControlName="building_type" id="building_type"
                (change)="setBuildingType()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let building of buildingTypes" [ngValue]="building.id">{{ building.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('building_type').touched && quoteForm.get('building_type').errors?.required">
                Building Type is required</span>
            </div>
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="organization_sector">* Organizational Sector</label>
              <select class="form-control" formControlName="organization_sector" id="organization_sector"
                (change)="setOrganizationalSector()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let org of organizationalTypes" [ngValue]="org.id">{{ org.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('organization_sector').touched && quoteForm.get('organization_sector').errors?.required">
                Organizational Sector is required</span>
            </div>
          </div>

          <div class="form-group">
            <label class="control-label" for="notes">Notes</label>
            <input type="text" class="form-control" formControlName="notes" />
          </div>

        </form>
      </div>

      <div class="container custom-section">
        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="section-heading">Delivery and Collection Area</span>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="guidance-text">This is the address where the modular building(s) will be delivered to</span>
          </div>
        </div>

        <form class="mt-3" [formGroup]="addressForm">

          <div class="row form-group">
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="shipping_address1">* Address line 1</label>
              <input type="text" class="form-control" formControlName="shipping_address1" />
              <span class="error"
                *ngIf="addressForm.get('shipping_address1').touched && addressForm.get('shipping_address1').errors?.required">
                Address line 1 is required</span>
            </div>
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="shipping_address2">Address line 2</label>
              <input type="text" class="form-control" formControlName="shipping_address2" />
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="shipping_suburb">* Suburb</label>
              <input type="text" class="form-control" formControlName="shipping_suburb" />
              <span class="error"
                *ngIf="addressForm.get('shipping_suburb').touched && addressForm.get('shipping_suburb').errors?.required">
                Suburb is required</span>
            </div>
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="shipping_postal">Postal code</label>
              <input type="text" class="form-control" formControlName="shipping_postal" />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-4 col-sm-12">
              <div class="form-group">
                <label class="control-label" for="shipping_province">* Province</label>
                <select class="form-control" formControlName="shipping_province" id="shipping_province"
                  (change)="setProvince()">
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
                </select>
                <span class="error"
                  *ngIf="addressForm.get('shipping_province').touched && addressForm.get('shipping_province').errors?.required">
                  Province is required</span>
              </div>
            </div>

            <div class="col-md-4 col-sm-12" *ngIf="showDistricts">
              <tan-loader [loading]="(transportDistrictsLoading$ | async)" [loadingText]="'<p>Loading Districts</p>'">
              </tan-loader>

              <div class="row justify-content-center" *ngIf="(transportDistrictsError$ | async)">
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Districts'">
                  </tan-alert-message>
                </div>
              </div>

              <div class="form-group"
                *ngIf="!(transportDistrictsLoading$ | async) && !(transportDistrictsError$ | async)">
                <label class="control-label" for="shipping_district">* District</label>
                <select class="form-control" formControlName="shipping_district" id="shipping_district"
                  (change)="setDistrict()">
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let district of transportDistricts" [ngValue]="district.id">{{ district.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-4 col-sm-12" *ngIf="showAreas">
              <tan-loader [loading]="(transportAreasLoading$ | async)" [loadingText]="'<p>Loading Areas</p>'">
              </tan-loader>

              <div class="row justify-content-center" *ngIf="(transportAreasError$ | async)">
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Areas'"></tan-alert-message>
                </div>
              </div>

              <div class="form-group" *ngIf="!(transportAreasLoading$ | async) && !(transportAreasError$ | async)">
                <label class="control-label" for="shipping_area">* Area</label>
                <select class="form-control" formControlName="shipping_area" id="shipping_area" (change)="setArea()">
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let area of transportAreas" [ngValue]="area.id">{{ area.name }}</option>
                </select>
                <span class="info guidance-text-blue">Select closest Area</span>
              </div>
            </div>
          </div>

          <div class="row mb-2" *ngIf="showProvinceMsg">
            <div class="col-sm-12">
              <span class="guidance-text">Collection of units quoted Ex-Works Kwikspace</span> <br>
              <span class="guidance-text">**An experienced sales consultant will be in contact with you to confirm
                your delivery location and if/where required, and provide a revised quotation**</span>
            </div>
          </div>

        </form>
      </div>

      <div class="row"
        *ngIf="quoteForm.valid && addressForm.valid && canSaveQuote && customerSelected && locationSelected">
        <div class="col-sm-12">
          <div class="container custom-section pt-2 pb-2 ar">
            <button type="button" class="btn btn-primary" (click)="saveQuote()">
              <span *ngIf="!(newCustomerLoading$ | async)">Next</span>
              <span *ngIf="(newCustomerLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Loading</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeStep == 2">
      <div class="row justify-content-center"
        *ngIf="(createProductConfigurationError$ | async) || (createLineItemError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not create Quote'"></tan-alert-message>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-sm-12">
          <div class="container custom-section">
            <div class="row mt-2">
              <div class="col-sm-12">
                <span class="section-heading">Unit Configuration</span>
              </div>
            </div>

            <ng-container *ngTemplateOutlet="unitConfig;"></ng-container>

          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="container custom-section">
            <div class="row mt-2">
              <div class="col-sm-12">
                <span class="section-heading">Quote Cart</span>
              </div>
            </div>
            <div class="row" *ngIf="quoteCart.length == 0">
              <div class="col-sm-12">
                <tan-alert-message [errorType]="'info'" [message]="'No items in cart yet'"></tan-alert-message>
              </div>
            </div>
            <div class="row" *ngIf="quoteCart.length > 0">
              <div class="col-sm-12">
                <ng-container *ngFor="let item of quoteCart">
                  <div class="row">
                    <label class="col-sm-12 col-form-label">
                      {{ item.name }}
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <span><strong>Description</strong></span>
                    </div>
                    <div class="col-sm-6">
                      <span><strong>Quantity</strong></span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6">
                      {{ item.item.name }}
                    </div>
                    <div class="col-sm-6">
                      {{ item.quantity }}
                    </div>
                  </div>

                  <ng-container *ngIf="item.extras.length > 0">
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="col-form-label">Added extras</label>
                      </div>
                    </div>
                    <ng-container *ngFor="let extra of item.extras">
                      <div class="row">
                        <div class="col-sm-6">
                          {{ extra.product }}
                        </div>
                        <div class="col-sm-6">
                          {{ extra.quantity }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="isSaProvince && item.transportOne">
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="col-form-label">Delivery Charges</label>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-sm-12">
                        Delivery and Collection -
                        {{ item.transportOne.transport.transportLocation.district.province.name }} -
                        {{ item.transportOne.transport.transportLocation.name }}
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="isSaProvince && item.transportJoin">
                    <div class="row mb-3">
                      <div class="col-sm-12">
                        Siting and Dismantling -
                        {{ item.transportOne.transport.transportLocation.district.province.name }} -
                        {{ item.transportOne.transport.transportLocation.name }}
                      </div>
                    </div>
                  </ng-container>

                </ng-container>

                <div class="row" *ngIf="canSave">
                  <div class="col-sm-12">
                    <div class="pt-2 pb-2 ar">
                      <button type="button" class="btn btn-primary" (click)="completeQuote()">
                        <span *ngIf="!(createLineItemLoading$ | async)">Save</span>
                        <span *ngIf="(createLineItemLoading$ | async)"><i
                            class="fa fa-spinner fa-spin"></i>Saving</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<tan-modal #optionalExtraModal [size]="'lg'" [title]="'Add Extra'" [showInformationBlock]="false"
  (onSave)="addOptionalExtraToLineItem()">
  <div modal-content>
    <div class="container">
      <form class="mt-3" [formGroup]="extrasForm">
        <div class="row form-group">
          <div class="col-sm-12">
            <label class="control-label" for="product_dropdown">Select Product</label>
            <select class="form-control" id="product_dropdown" formControlName="product" (change)="setProduct()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let product of filteredProducts" [ngValue]="product.id">{{ product.name }}</option>
            </select>
            <div *ngIf="filteredProducts.length == 0 && !(productsLoading$ | async)" class="mt-2">
              <tan-alert-message [errorType]="'info'" [message]="'No optional extras found for this selection'">
              </tan-alert-message>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="quantity">Quantity</label>
          <input type="text" class="form-control" formControlName="quantity"
            (ngModelChange)="validateLimitation($event)"  min="0" oninput="validity.valid||(value='')"/>
          <span class="info guidance-text-blue">Enter quantity required <strong>per unit</strong></span><br>
          <span class="info guidance-text" *ngIf="limitationError">Quantity cannot exceed {{ limitaion }} items for
            this unit</span>
        </div>

      </form>
    </div>
  </div>
</tan-modal>

<tan-modal #editOptionalExtraModal [size]="'lg'" [title]="'Edit Extra'" [showInformationBlock]="false"
  (onSave)="editOptionalExtraToLineItem()">
  <div modal-content>
    <div class="container">
      <form class="mt-3" [formGroup]="editExtrasForm">
        <div class="row form-group">
          <div class="col-sm-12">
            <label class="control-label" for="product_dropdown">Select Product</label>
            <select class="form-control" id="product_dropdown" formControlName="product" (change)="setProduct()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let product of filteredProducts" [ngValue]="product.id">{{ product.name }}</option>
            </select>
            <div *ngIf="filteredProducts.length == 0 && !(productsLoading$ | async)" class="mt-2">
              <tan-alert-message [errorType]="'info'" [message]="'No optional extras found for this selection'">
              </tan-alert-message>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="quantity">Quantity</label>
          <input type="text" class="form-control" formControlName="quantity"
            (ngModelChange)="validateLimitation($event)"  min="0" oninput="validity.valid||(value='')"/>
          <span class="info guidance-text-blue">Enter quantity required <strong>per unit</strong></span><br>
          <span class="info guidance-text" *ngIf="limitationError">Quantity cannot exceed {{ limitaion }} items for
            this unit</span>
        </div>

      </form>
    </div>
  </div>
</tan-modal>

<tan-modal #unitAddedModal [size]="'lg'" [title]="'Unit added'" [showInformationBlock]="false"
  [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <span class="info guidance-text-blue">Unit was added to cart.</span>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <span class="info guidance-text-blue">Another unit can be configured on left side of screen, if
            required.</span>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <span class="info guidance-text-blue">Click 'Save' on right hand side to proceed with quote.</span>
        </div>
      </div>

    </div>
  </div>
</tan-modal>

<tan-modal #drawingModal [size]="'xl'" [title]="'Layout'" [showInformationBlock]="false" [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 d-flex justify-content-center">
          <div class="row justify-content-center" *ngIf="drawingImg == ''">
            <div class="col-sm-12 d-flex justify-content-center">
              <tan-alert-message [errorType]="'error'" [message]="'Could not find image'"></tan-alert-message>
            </div>
          </div>
          <ng-container *ngIf="drawingImg != ''">
            <img class="img-size" [src]="drawingImg" alt="logo">
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<ng-template #unitConfig let-item>

  <form class="mt-3" [formGroup]="rentalForm">
    <div class="row mt-2">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="rental_option_category">Category</label>
          <select class="form-control" formControlName="rental_option_category" id="rental_option_category"
            (change)="setRentalCategory()">
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let cat of rentalCategories" [ngValue]="cat.id">{{ cat.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="showPeriodDD">
        <div class="form-group">
          <label class="control-label" for="rental_period">Period</label>
          <select class="form-control" formControlName="rental_period" id="rental_period" (change)="setPeriod()">
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let period of rentalPeriods" [ngValue]="period.id">{{ period.period }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="showSize">
        <div class="form-group">
          <label class="control-label" for="rental_size">Size</label>
          <select class="form-control" formControlName="rental_size" id="rental_size" (change)="setSize()">
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let size of rentalSizes" [ngValue]="size.id">{{ size.size }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mt-2" *ngIf="showRentalOptions">
      <div class="col-sm-6" *ngIf="!periodIsSet">
        <div class="form-group">
          <label class="control-label" for="rental_months">Actual Months</label>
          <input type="number" class="form-control" formControlName="rental_months"
            (ngModelChange)="validateMinMaxMonths()" [value]="actualMonths" />
          <span class="info guidance-text-blue">Actual months required for</span><br>
          <span class="error"
            *ngIf="rentalForm.get('rental_months').touched && rentalForm.get('rental_months').errors?.required">
            Actual months is required</span><br>
          <span class="error" *ngIf="rentalMonthsError">{{ rentalMonthsErrorMsg }}</span>
        </div>
      </div>
      <div class="col-sm-6" *ngIf="showQty">
        <div class="form-group">
          <label class="control-label" for="unit_qty">Quantity required</label>
          <input type="number" class="form-control" formControlName="unit_qty" (ngModelChange)="setUnitQty()"
            [value]="unitQty"  min="0" oninput="validity.valid||(value='')"/>
          <span class="info guidance-text-blue">How many of these (with same configuration) do you want?</span><br>
          <span class="error" *ngIf="rentalForm.get('unit_qty').touched && rentalForm.get('unit_qty').errors?.required">
            Qty is required</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showRentalOptions && !rentalMonthsError && qtyEntered">
      <tan-loader [loading]="(getRentalPriceListLoading$ | async)" [loadingText]="'<p>Loading pricing..</p>'">
      </tan-loader>

      <label class="control-label" for="rental_option" *ngIf="!hasPricing">Rental Option</label>
      <div class="row d-flex justify-content-center" *ngIf="!hasPricing">
        <div class="col-sm-12 d-flex justify-content-center">
          <button type="button" class="btn btn-primary action-btn" (click)="getRentalPriceList()">
            <span>Retry?</span>
          </button>
        </div>
      </div>

      <div class="form-group" *ngIf="!(getRentalPriceListLoading$ | async) && hasPricing">
        <label class="control-label" for="rental_option">Rental Option</label>
        <select class="form-control" formControlName="rental_option" id="rental_option" (change)="setRentalOption()">
          <option [ngValue]="null">Please select</option>
          <option *ngFor="let option of rentalPricing" [ngValue]="option.id">{{ option.name }}</option>
        </select>
      </div>
    </ng-container>

    <tan-loader [loading]="rentalLoading" [loadingText]="'<p>Configuring Rental Option</p>'">
    </tan-loader>

    <ng-container *ngIf="!isClassroom && showTransport && showTransportSize">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_one">* Truck Size</label>
            <select [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" class="form-control"
              formControlName="transport_load_one" id="transport_load_one" (change)="setSelectedTransportLoadOne()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                {{ size.size }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_one_qty">* Qty of Trucks required</label>
            <input [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" type="number"
              class="form-control" formControlName="transport_load_one_qty"
              (ngModelChange)="loadOneQtyUpdate.next($event)" />
            <span class="error"
              *ngIf="rentalForm.get('transport_load_one_qty').touched && rentalForm.get('transport_load_one_qty').errors?.required">
              Qty is required</span><br>
          </div>
        </div>
        <tan-loader [loading]="transportOneLoading" [loadingText]="'<p>Calculating charges..</p>'">
        </tan-loader>
        <div class="row justify-content-center" *ngIf="!transportOneLoading && 
                !transportOneHasPricing && 
                selectedTransportLoadOne?.load &&
                selectedTransportLoadOne?.quantity">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'No transport found for selected truck size'">
            </tan-alert-message>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isClassroom && showTransport && showTransportSize && addSecondTransportLoad">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_two">* Truck Size</label>
            <select [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" class="form-control"
              formControlName="transport_load_two" id="transport_load_two" (change)="setSelectedTransportLoadTwo()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                {{ size.size }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_two_qty">* Qty of Trucks required</label>
            <input [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" type="number"
              class="form-control" formControlName="transport_load_two_qty"
              (ngModelChange)="loadTwoQtyUpdate.next($event)" />
            <span class="error"
              *ngIf="rentalForm.get('transport_load_two_qty').touched && rentalForm.get('transport_load_two_qty').errors?.required">
              Qty is required</span><br>
          </div>
        </div>
        <tan-loader [loading]="transportTwoLoading" [loadingText]="'<p>Calculating charges..</p>'">
        </tan-loader>
        <div class="row justify-content-center" *ngIf="!transportTwoLoading && 
                  !transportTwoHasPricing && 
                  selectedTransportLoadTwo?.load &&
                  selectedTransportLoadTwo?.quantity">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'No transport found for selected truck size'">
            </tan-alert-message>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row" *ngIf="!isClassroom && showTransportGuide">
      <div class="col-sm-12 ">
        <span class="guidance-text"><strong>Note:</strong></span><br>
        <span class="guidance-text">1. A single 3m/6m building could be transported on a 6m truck</span><br>
        <span class="guidance-text">2. A single 9m/12m building could be transported on a 12m truck</span><br>
        <span class="guidance-text">3. Two 6m buildings can be transported on a 12m truck</span><br>
        <span class="guidance-text">4. Two 3m building can be transported on a 6m truck</span><br>
        <span class="guidance-text">5. Classroom transport price calculated automatically</span><br>
        <span class="guidance-text">6. The transport price has been provided as an estimate, please contact a Kwikspace representative for discounted rates, where units can be placed on combined load/truck sizes.</span>
      </div>
    </div>

    <div class="row justify-content-center mt-3 mb-3"
      *ngIf="!isClassroom && showTransport && showTransportSize && !addSecondTransportLoad">
      <div class="col-sm-12 d-flex justify-content-center">
        <button type="button" class="btn btn-primary truck-btn" (click)="addAnotherTruck()">
          <span>Add another truck</span>
        </button>
      </div>
    </div>

    <div class="form-group mt-2" *ngIf="!isClassroom && showTransportCharge">

      <ng-container>
        <tan-loader [loading]="(transportPricingLoading$ | async)" [loadingText]="'<p>Loading charges..</p>'">
        </tan-loader>

        <label class="control-label" for="rental_transport" *ngIf="!hasTransportPricing">Confirm Transport
          Charges</label>
        <div class="row d-flex justify-content-center" *ngIf="!hasTransportPricing">
          <div class="col-sm-12 d-flex justify-content-center">
            <button type="button" class="btn btn-primary action-btn" (click)="getTransportAllPricing()">
              <span>Retry?</span>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="!(transportPricingLoading$ | async) && !(transportPricingError$ | async) && hasTransportPricing">
        <label class="control-label" for="rental_transport">Confirm Transport Charges</label>
        <select class="form-control" formControlName="rental_transport" id="rental_transport"
          (change)="setTransportOption()">
          <option [ngValue]="null">Please select</option>
          <option *ngFor="let transport of transportPricing" [ngValue]="transport.id">
            {{ transport.transportLocation.district.name }} - {{ transport.transportLocation.name }} -
            {{ transport.transportCharge.name }}</option>
        </select>
      </ng-container>

    </div>

    <ng-container *ngIf="showOptionDescription">
      <div class="row">
        <label class="col-sm-12 col-form-label">
          You have selected the below option:
        </label>
      </div>
      <div class="row mb-2">
        <div class="col-sm-9">
          {{ selectedOption.category.name }} - {{ selectedOption.item.description }} -
          {{ selectedOption.size.size }} - {{ selectedOption.period.period }}
        </div>
        <div class="col-sm-3 ar">
          <div class="d-inline-block">
            <button class="btn btn-secondary table-filter-btn" id="viewDrawing" (click)="showDrawing()">
              <span class="fa fa-eye text-white"></span> View
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3 mb-2">
        <label class="col-sm-8 col-form-label" for="optional_extras">
          Do you wish to add any optional extras?
        </label>
        <div class="col-md-4">
          <input type="checkbox" class="form-control comparison-check form-input-check" [checked]="showOptionalExtras"
            formControlName="optional_extras" id="optional_extras" (click)="addExtras($event.target.checked)">
        </div>
      </div> -->

      <div class="row">
        <div class="col-sm-12">
          <div class="row" *ngIf="quoteLineItem.extras.length > 0">
            <div class="col-sm-12">
              <div class="row">
                <label class="col-sm-12 col-form-label">
                  Added extras:
                </label>
              </div>
              <ng-container *ngFor="let extra of quoteLineItem.extras; let j = index">
                <div class="row mb-2 extras-row">
                  <div class="col-sm-6 row-item-pad">
                    {{ extra.product }}
                  </div>
                  <div class="col-sm-2 row-item-pad">
                    {{ extra.quantity }}
                  </div>
                  <div class="col-sm-4">
                    <button class="primary-button icon-btn btn-color-delete" (click)="deleteExtra(extra, j)">
                      <span class="fa fa-trash" aria-hidden="true"></span>
                    </button>
                    <button class="primary-button icon-btn btn-color-primary" (click)="editExtra(extra, j)">
                      <span class="fa fa-pencil" aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="row mt-1">
            <div class="col-sm-12 d-flex justify-content-center">
              <button type="button" class="btn btn-primary action-btn" (click)="addOptionalExtra()">
                <span>Add Extra</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-3 mb-3"
        *ngIf="showOptionDescription && (showTransport || !isSaProvince)">
        <div class="col-sm-12 d-flex justify-content-center">
          <button type="button" class="btn btn-primary action-btn" (click)="addToCart()">
            <span>Add to Cart</span>
          </button>
        </div>
      </div>

    </ng-container>

  </form>
</ng-template>

<tan-modal
  #removeExtrasModal
  [size]="'sm'"
  [title]="'Confirm'"
  [showInformationBlock]="false"
  (onSave)="removeExtras()"
>
  <div modal-content>
    <div class="container">
      <ng-container *ngTemplateOutlet="confirmRemoveExtrasContent"></ng-container>
    </div>
  </div>
</tan-modal>

<ng-template #confirmRemoveExtrasContent>
  <ng-container>
    <p>Are you sure you want to remove all optional extras?</p>
  </ng-container>
</ng-template>